export const config = {
  org: {
    icon: 'https://img.alicdn.com/tfs/TB15i1VCEz1gK0jSZLeXXb9kVXa-70-104.png',
    title: '省卫健委合作项目',
    list: [
      { name: '居民电子健康卡', path: '/solution?id=1&tab=0' },
      { name: '互联网医院平台', path: '/solution?id=1&tab=1' },
      { name: '处方交换及监管中心', path: '/solution?id=1&tab=2' },
    ],
  },
  hospital: {
    icon: 'https://img.alicdn.com/tfs/TB1MIK2CxD1gK0jSZFyXXciOVXa-90-104.png',
    title: '智慧医院',
    list: [
      { name: '标准化数据中心', path: '/solution?id=2&tab=0' },
      { name: '智慧服务', path: '/solution?id=2&tab=1' },
      { name: '智慧临床', path: '/solution?id=2&tab=2' },
      { name: '智慧管理', path: '/solution?id=2&tab=3' },
    ],
  },
  healthPlatform: {
    icon: 'https://img.alicdn.com/tfs/TB19Cy2Cq61gK0jSZFlXXXDKFXa-84-102.png',
    title: '全民健康信息平台',
    list: [
      { name: '健康医疗数据中心', path: '/solution?id=3&tab=0' },
      { name: '便民惠民应用', path: '/solution?id=3&tab=1' },
      { name: '智慧临床应用', path: '/solution?id=3&tab=2' },
      { name: '监管运营应用', path: '/solution?id=3&tab=3' },
    ],
  },
};
